import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import TrustBar from "@/components/TrustBar";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time for assets
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App min-h-screen bg-slate-950">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Loader isLoading={loading} />
        
        <div className={`transition-opacity duration-500 ${loading ? 'opacity-0' : 'opacity-100'}`}>
          <Navbar />
          <main>
            <Hero />
            <About />
            <Services />
            <TrustBar />
            <Contact />
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
